// @flow

import type {
  Baby,
  BabyState,
  BabiesFilterType,
  BabiesSortByProperty,
  BabiesState,
  ThunkAction,
  Action,
  GetState,
  Dispatch,
  Sex,
} from "../types"
import {get, put} from "../client"

export const fetchBabiesMadams = (): ThunkAction => {
  return (dispatch: Dispatch) => {
    return get(`/babies/madams`).then((response) => {
      if (response.data) {
        dispatch(setBabiesMadams(response.data))
        return
      }
      // toast.error(i18n.t('toast.babies.fetch.error'))
    })
  }
}

export const fetchBabies = (): ThunkAction => {
  return (dispatch: Dispatch) => {
    return get(`/babies`).then((response) => {
      if (response.data) {
        dispatch(setBabies(response.data))
        return
      }
      // toast.error(i18n.t('toast.babies.fetch.error'))
    })
  }
}

export const fetchBabiesPaged = (): ThunkAction => {
  return (dispatch: Dispatch, getState: GetState) => {
    const {babies} = getState()
    const q = buildFilterQuery(babies)
    return get(`/babies${q}`).then((response) => {
      if (response.data) {
        dispatch(setBabiesPage(response.pageNumber))
        dispatch(setBabiesTotalPages(response.totalPages))
        dispatch(setBabies(response.data))
        return
      }
      // toast.error(i18n.t('toast.babies.fetch.error'))
    })
  }
}

const buildFilterQuery = (state: BabiesState): string => {
  const {filters, page, query, sortBy, listType} = state
  let q = []

  q.push(`lt=${listType}`)
  q.push(`p=${page}`)
  q.push(`q=${encodeURIComponent(query)}`)

  Object.keys(filters).forEach((key) =>
    q.push(`${key}=${encodeURIComponent(filters[key])}`)
  )

  q.push(`sp=${sortBy.property}`)
  q.push(`so=${sortBy.order}`)

  return q.length > 0 ? "?" + q.join("&") : ""
}

export const setBabiesMadams = (madams: $ReadOnlyArray<BabyMadam>): Action => ({
  type: "SET_BABIES_MADAMS",
  madams,
})

export const setBabies = (babies: $ReadOnlyArray<Baby>): Action => ({
  type: "SET_BABIES",
  babies,
})

export const setBabiesPage = (page: number): Action => ({
  type: "SET_BABIES_PAGE",
  page,
})

export const setBabiesTotalPages = (totalPages: number): Action => ({
  type: "SET_BABIES_TOTAL_PAGES",
  totalPages,
})

export const setBaby = (baby: Baby): Action => ({
  type: "SET_BABIES_BABY",
  baby,
})

export const setBabyBorn = (
  babyToken: string,
  firstname: string,
  sex: Sex,
  birthDate: string
): ThunkAction => {
  return (dispatch: Dispatch) => {
    return put(`/babies/${babyToken}/born`, {
      firstname,
      sex,
      birthDate,
    }).then((response) => {
      if (response.data) {
        dispatch(setBaby(response.data))
      }
    })
  }
}

export const updateBabyState = (
  babyToken: string,
  state: BabyState,
  reason: string = ""
): ThunkAction => {
  return (dispatch: Dispatch) => {
    return put(`/babies/${babyToken}/state`, {
      state,
      reason,
    }).then((response) => {
      if (response.data) {
        dispatch(setBaby(response.data))
      }
    })
  }
}

export const setBabiesFilter = (
  filter: BabiesFilterType,
  value: any
): Action => ({
  type: "SET_BABIES_FILTER",
  filter,
  value,
})

export const setBabiesQuery = (query: string): Action => ({
  type: "SET_BABIES_QUERY",
  query,
})

export const setBabiesListType = (listType: ListType): Action => ({
  type: "SET_BABIES_LIST_TYPE",
  listType,
})

export const resetBabiesFilters = (): Action => ({
  type: "RESET_BABIES_FILTERS",
})

export const toggleBabiesSortBy = (
  sortByProp: BabiesSortByProperty
): Action => ({
  type: "TOGGLE_BABIES_SORT_BY",
  sortByProp,
})

export const updateBabyIntake = (
  babyToken: string,
  intakeDate: string,
  intakeLocation: string = ""
): ThunkAction => {
  return (dispatch: Dispatch) => {
    return put(`/babies/${babyToken}/intake`, {
      intakeDate,
      intakeLocation,
    }).then((response) => {
      if (response.data) {
        dispatch(setBaby(response.data))
      }
      // toast.success(i18n.t('toast.baby.offerSend.success'))
    })
  }
}
